import { autoserialize, autoserializeAs } from 'cerialize';
import { OrganizationPaymentMethod } from './organization-payment-method';
import { OrganizationServiceLevel } from './organization-service-level';
import { DateUtil, isNullOrUndefined } from '@uzurv/core';

export class OrganizationRiderListItem {
  @autoserialize
  riderId: number;

  @autoserialize
  organizationRiderId: number;

  @autoserialize
  name: string;

  @autoserialize
  emailAddress: string;

  @autoserialize
  firstName: string;

  @autoserialize
  lastName: string;

  @autoserializeAs(Date)
  dateOfBirth: Date;

  @autoserialize
  phoneNumber: string;

  @autoserialize
  partnerIdentifier: string;

  @autoserialize
  organizationId: number;

  @autoserialize
  organizationCode: string;

  @autoserialize
  organizationName: string;

  @autoserialize
  riderAppEnabled: boolean;

  @autoserialize
  riderAppItineraryCreationEnabled: boolean;

  @autoserialize
  riderPaymentRequired: boolean;

  @autoserialize
  driverIdBadgeRequired: boolean;

  @autoserialize
  riderPaymentAccountEnabled: boolean;

  @autoserialize
  riderFareCollectionEnabled: boolean;

  @autoserialize
  scheduleByPickupOnly: boolean;

  @autoserialize
  scheduleByDropoffOnly: boolean;

  @autoserializeAs(OrganizationPaymentMethod)
  supportedPaymentMethods: Array<OrganizationPaymentMethod>;

  @autoserialize
  eligible: boolean;

  @autoserialize
  bookingPhoneNumber: string;

  @autoserialize
  riderEligibilityPhoneNumber: string;

  @autoserialize
  riderAppContactInformationUpdatesEnabled: boolean;

  @autoserialize
  pcaApproved: boolean;

  @autoserialize
  pcaEligible: boolean;

  @autoserialize
  preferredProviderEnabled: boolean;

  @autoserialize
  proofed: boolean;

  @autoserializeAs(OrganizationServiceLevel)
  organizationServiceLevels: Array<OrganizationServiceLevel>;

  // Local Variables

  get eligibilityText(): string {
    return this.eligible ? 'Eligible' : 'Ineligible';
  }

  static OnSerialized(instance: OrganizationRiderListItem, json: any): void {
    if (!isNullOrUndefined(instance.dateOfBirth)) {
      json.dateOfBirth = DateUtil.serializeLocalDate(instance.dateOfBirth);
    }

    if (!isNullOrUndefined(instance.firstName)) {
      json.firstName = instance.firstName.trim();
    }

    if (!isNullOrUndefined(instance.lastName)) {
      json.lastName = instance.lastName.trim();
    }

    if (!isNullOrUndefined(instance.emailAddress)) {
      json.emailAddress = instance.emailAddress.toLowerCase().trim();
    }
  }

  static OnDeserialized(instance: OrganizationRiderListItem, json: any): void {
    if (!isNullOrUndefined(json['dateOfBirth'])) {
      instance.dateOfBirth = DateUtil.deserializeLocalDate(json['dateOfBirth']);
    }
  }
}
